import { render, staticRenderFns } from "./VideoComments.vue?vue&type=template&id=66927852&"
import script from "./VideoComments.vue?vue&type=script&lang=js&"
export * from "./VideoComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports